import React from 'react';
import agroImage from '../assets/images/kab agri.jpeg';
import homeImage from '../assets/images/kabiniz.png';

const FeatureCards = () => {
  return (
    <section id="featured-cards" className="py-5">
      <div className="container-fluid padding-side">
        <div className="row g-4 align-items-stretch">
          {/* AGRO CARD - left */}
          <div className="col-md-6" data-aos="fade-up" data-aos-delay="100" data-aos-duration="900">
            <div className="big-card position-relative" style={{ height: '520px' }}>
              <img 
                src={agroImage} 
                alt="Agro Products" 
                onError={(e) => {
                  e.target.src = 'https://picsum.photos/id/104/800/600';
                }}
              />
              <div className="card-content position-absolute bottom-0 start-0 w-100 text-white d-flex flex-column justify-content-end">
                <span className="badge-yellow mb-3" style={{ width: 'fit-content', boxShadow: '0 6px 14px #0008CB' }}>
                  🌽 farm fresh · organic
                </span>
                <h3 className="display-4 fw-normal fw-bold" style={{ color: '#FFEA00', textShadow: '0 2px 6px #000' }}>
                  Agro Products
                </h3>
                <p className="fs-5 mb-4" style={{ color: 'rgba(255,255,255,0.9)', maxWidth: '90%' }}>
                  Organic fruits, vegetables, herbs from our own gardens. Taste purity.
                </p>
                <a href="/agroindex" className="btn btn-outline-yellow rounded-pill py-3 px-5 align-self-start d-flex align-items-center gap-2">
                  <span>Explore harvest</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* HOME STAYS CARD - right */}
          <div className="col-md-6" data-aos="fade-up" data-aos-delay="200" data-aos-duration="900">
            <div className="big-card position-relative" style={{ height: '520px' }}>
              <img 
                src={homeImage} 
                alt="Home Stays" 
                onError={(e) => {
                  e.target.src = 'https://picsum.photos/id/128/800/600';
                }}
              />
              <div className="card-content position-absolute bottom-0 start-0 w-100 text-white d-flex flex-column justify-content-end">
                <span className="badge-deepblue mb-3" style={{ width: 'fit-content', boxShadow: '0 6px 14px #FFEA00' }}>
                  🏕️ living · traditional
                </span>
                <h3 className="display-4 fw-normal fw-bold" style={{ color: '#0008CB', textShadow: '0 2px 6px #ffffff70' }}>
                  Home Stay
                </h3>
                <p className="fs-5 mb-4" style={{ color: 'rgba(255,255,255,0.95)' }}>
                  Authentic local life in traditional homes. Modern comfort & rustic charm.
                </p>
                <a href="/homestay" className="btn btn-primary-custom rounded-pill py-3 px-5 align-self-start d-flex align-items-center gap-2">
                  <span>Book your stay</span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M5 12h14M12 5l7 7-7 7"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureCards;